"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreviousUrl = void 0;
var _reselect = require("reselect");
var getUrlHistory = function getUrlHistory(state) {
  return state.urlHistory;
};
var getPreviousUrl = (0, _reselect.createSelector)(getUrlHistory, function (urlHistory) {
  if (urlHistory.length < 2) {
    return null;
  }
  return urlHistory[urlHistory.length - 2].url;
});
exports.getPreviousUrl = getPreviousUrl;